"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=(l={})=>[l==null?void 0:l.firstName,l==null?void 0:l.lastName].filter(Boolean).join(" ");exports.getPatientFullname=e;
